import React from 'react';
import cx from 'classnames';

type Props = {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  wide?: boolean;
  children: React.ReactNode;
};

function AuthCard({ title, subtitle, eyebrow, wide = false, children }: Props) {
  return (
    <div
      className={cx(
        'mx-auto mt-6 rounded-3xl bg-white/70 p-0 sm:p-2 lg:mt-12',
        wide ? 'max-w-[840px]' : 'max-w-[456px]',
      )}
    >
      <div className="rounded-3xl bg-white px-4 py-6 sm:rounded-2xl sm:px-6 sm:py-8 lg:p-8">
        {eyebrow && (
          <p className="text-center text-[13px] font-semibold uppercase tracking-widest text-retino-darkviolet/70">
            {eyebrow}
          </p>
        )}
        <h1
          className={cx('text-balance text-center font-semibold leading-tight text-retino-darkviolet', {
            'mt-4': eyebrow,
            'text-2xl lg:text-[28px]': !wide,
            'text-[28px] lg:text-[32px]': wide,
          })}
        >
          {title}
        </h1>
        {subtitle && <p className="mt-3 text-center text-base leading-snug text-black">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}

export default AuthCard;
